<div class="dialog">
    <header class="dialog-header">
        <div>
            <h2>{{ title }}</h2>
            <p>{{ description }}</p>
        </div>

        <button type="button" class="close-button" (click)="close()" aria-label="Dialog schließen"
            [disabled]="isSaving()">
            <mat-icon fontSet="material-icons-outlined">close</mat-icon>
        </button>
    </header>

    <form class="dialog-form" [formGroup]="form" (ngSubmit)="submit()">
        @if (data.mode === 'create') {
        @if (data.isCopagoAdminMode) {
        <label class="field">
            <span>Tenant ID</span>
            <input type="text" formControlName="tenantId" placeholder="z. B. 60000001" />

            @if (form.controls.tenantId.touched && form.controls.tenantId.hasError('required')) {
            <small>Tenant ID ist erforderlich.</small>
            }
        </label>
        }

        <label class="field">
            <span>E-Mail</span>
            <input type="text" formControlName="email" placeholder="name@firma.de" />

            @if (form.controls.email.touched && form.controls.email.hasError('required')) {
            <small>E-Mail ist erforderlich.</small>
            }

            @if (form.controls.email.touched && form.controls.email.hasError('pattern')) {
            <small>Bitte geben Sie eine gültige E-Mail-Adresse ein.</small>
            }
        </label>

        <label class="field">
            <span>Benutzername (optional)</span>
            <input type="text" formControlName="benutzername" placeholder="z. B. m.mustermann" />
        </label>

        <label class="field">
            <span>Initiales Passwort</span>

            <div class="password-field">
                <input [type]="showPassword() ? 'text' : 'password'" formControlName="passwort"
                    placeholder="Mind. 8 Zeichen" />

                <button type="button" class="password-toggle-button" (click)="togglePasswordVisibility()"
                    [disabled]="isSaving()">
                    <mat-icon fontSet="material-icons-outlined">
                        {{ showPassword() ? 'visibility_off' : 'visibility' }}
                    </mat-icon>
                </button>
            </div>

            @if (form.controls.passwort.touched && form.controls.passwort.hasError('minlength')) {
            <small>Das Passwort muss mindestens 8 Zeichen haben.</small>
            }
        </label>
        }

        @if (data.mode === 'edit') {
        @if (data.isCopagoAdminMode) {
        <label class="field">
            <span>Tenant ID</span>

            <div class="readonly-display">
                {{ form.controls.tenantId.value }}
            </div>

            @if (form.controls.tenantId.touched && form.controls.tenantId.hasError('required')) {
            <small>Tenant ID ist erforderlich.</small>
            }
        </label>
        }

        <label class="field">
            <span>E-Mail</span>

            @if (data.isCopagoAdminMode) {
            <input type="text" formControlName="email" placeholder="name@firma.de" />

            @if (form.controls.email.touched && form.controls.email.hasError('required')) {
            <small>E-Mail ist erforderlich.</small>
            }

            @if (form.controls.email.touched && form.controls.email.hasError('pattern')) {
            <small>Bitte geben Sie eine gültige E-Mail-Adresse ein.</small>
            }
            } @else {
            <div class="readonly-display">
                {{ form.controls.email.value }}
            </div>
            }
        </label>

        <label class="field">
            <span>Benutzername </span>

            @if (data.isCopagoAdminMode) {
            <input type="text" formControlName="benutzername" placeholder="z. B. m.mustermann" />
            } @else {
            <div class="readonly-display">
                {{ form.controls.benutzername.value }}
            </div>
            }
        </label>
        }

        <div class="form-grid">
            <label class="field">
                <span>Vorname</span>
                <input type="text" formControlName="vorname" placeholder="Max" />

                @if (form.controls.vorname.touched && form.controls.vorname.hasError('required')) {
                <small>Vorname ist erforderlich.</small>
                }
            </label>

            <label class="field">
                <span>Nachname</span>
                <input type="text" formControlName="nachname" placeholder="Mustermann" />

                @if (form.controls.nachname.touched && form.controls.nachname.hasError('required')) {
                <small>Nachname ist erforderlich.</small>
                }
            </label>
        </div>

        @if (data.mode === 'edit') {
        <section class="selection-section mobile-only">
            <h3>Module</h3>

            <div class="readonly-module-list">
                @for (modul of data.benutzer?.module ?? []; track modul) {
                <div class="readonly-module-item">
                    <span class="readonly-module-chip">{{ modul }}</span>
                </div>
                }
            </div>
        </section>
        }

        @if (!data.isCopagoAdminMode) {
        @if (isCurrentUserEdit) {
        <section class="selection-section">
            <h3>Rollenzuweisung</h3>

            <div class="restriction-message">
                <mat-icon fontSet="material-icons-outlined">lock</mat-icon>
                <span>Sie sind nicht berechtigt, Ihre eigenen Rollen zu ändern.</span>
            </div>
        </section>

        <section class="selection-section">
            <h3>Filialzuordnung</h3>

            <div class="restriction-message">
                <mat-icon fontSet="material-icons-outlined">lock</mat-icon>
                <span>Sie sind nicht berechtigt, Ihre eigene Filialzuordnung zu ändern.</span>
            </div>
        </section>
        } @else {
        <section class="selection-section">
            <h3>Rollenzuweisung</h3>

            <div class="selection-list">
                @for (rolle of rollen; track rolle.id) {
                <button type="button" class="selection-item" (click)="toggleRolle(rolle.id)" [disabled]="isSaving()">
                    <span class="fake-checkbox" [class.checked]="isRolleSelected(rolle.id)"></span>

                    <span class="selection-content">
                        <strong>{{ rolle.label }}</strong>

                        @if (rolle.badge) {
                        <span class="chip">
                            <mat-icon fontSet="material-icons-outlined">shield</mat-icon>
                            {{ rolle.badge }}
                        </span>
                        }
                    </span>
                </button>
                }
            </div>

            @if (roleError()) {
            <div class="section-error">
                Mindestens eine Rolle muss zugewiesen werden.
            </div>
            }
        </section>

        <section class="selection-section">
            <h3>Filialzuordnung</h3>

            <div class="selection-list filial-list">
                @for (filiale of filialen; track filiale.id) {
                <button type="button" class="selection-item compact" (click)="toggleFiliale(filiale.id)"
                    [disabled]="isSaving()">
                    <span class="fake-checkbox" [class.checked]="isFilialeSelected(filiale.id)"></span>

                    <mat-icon class="item-icon" fontSet="material-icons-outlined">
                        {{ filiale.icon }}
                    </mat-icon>

                    <span class="selection-content">
                        <strong>{{ filiale.label }}</strong>
                    </span>
                </button>
                }
            </div>
        </section>
        }
        }

        <footer class="dialog-actions">
            <button type="button" class="secondary-button" (click)="close()" [disabled]="isSaving()">
                Abbrechen
            </button>

            <button type="submit" class="primary-button" [disabled]="isSaving()">
                {{ isSaving() ? 'Speichern...' : submitLabel }}
            </button>
        </footer>
    </form>
</div>